const themeBlack = {
  name: 'black',
  typography: {
    primary: 'Orbitron, sans-serif',
    secondary: 'Electrolize, sans-serif'
  },
  color: {
    accent: 0.2,
    alpha: 0.5,
    primary: {
      dark: '#71717a',
      main: '#f4f4f5',
      light: '#ffffff'
    },
    secondary: {
      dark: '#52525b',
      main: '#e4e4e7',
      light: '#ffffff'
    },
    tertiary: {
      dark: '#71717a',
      main: '#ffffff',
      light: '#ffffff'
    },
    heading: {
      main: '#ffffff'
    },
    text: {
      main: '#a1a1aa'
    },
    link: {
      dark: '#71717a',
      main: '#e4e4e7',
      light: '#ffffff'
    },
    background: {
      dark: '#000000',
      main: '#09090b',
      light: '#18181b'
    }
  },
  animation: {
    time: 250,
    stagger: 50
  }
};

module.exports = themeBlack;

// Commit trace: 2026-03-21T19:55:19 - style: improve code style in theme.js

// Commit trace: 2026-04-12T21:43:55 - style: update lint compliance in theme.js
